export default "__VITE_PUBLIC_ASSET__97dc3396__"